exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".von-popover{position:absolute;z-index:10;padding:4px;min-width:40px;visibility:hidden;transition:opacity .3s ease-out;-webkit-transition:opacity .3s ease-out;opacity:0}.von-popover.visible{visibility:visible}.von-popover.active{opacity:1}.von-popover .von-popover-content{background-color:rgba(0,0,0,.8);color:#fff;font-size:13px;line-height:13px;padding:15px 12px 14px;border-radius:2px;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2)}.von-popover .von-popover-content.has-close{padding-right:37px}.grade-b .von-popover .von-popover-content{line-height:13px;padding:15px 12px 14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/popover/index.vue
// module id = 171
// module chunks = 0